import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./_materialShared.scss";

// Shared shimmer / skeleton blocks for the Material (Report / Store) modules,
// matching the Finance module's skeleton aesthetic.

export const Shimmer = ({ width = "100%", height = 14, radius = 6, style = {} }) => (
    <div className="matx-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

export const MaterialTableShimmer = ({ rows = 6, cols = 7 }) => {
    const widths = [120, 80, 130, 90, 90, 90, 90, 90];
    const cells = widths.slice(0, cols);
    return (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 20px" }}>
            <div style={{ display: "flex", gap: 16, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                {cells.map((w, i) => <Shimmer key={i} width={w} height={13} style={{ flexShrink: 0 }} />)}
            </div>
            {Array.from({ length: rows }).map((_, r) => (
                <div key={r} style={{ display: "flex", gap: 16, padding: "14px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                    {cells.map((w, i) => <Shimmer key={i} width={w} height={12} style={{ flexShrink: 0 }} />)}
                </div>
            ))}
        </div>
    );
};

// Full-page card skeleton (tab strip + header + filter row + table).
export const MaterialPageShimmer = ({ filters = 5 }) => (
    <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>
        <Container fluid className="px-0">
            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                {/* Tab strip */}
                <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "14px 24px", display: "flex", gap: 10 }}>
                    {[0, 1, 2].map((i) => <Shimmer key={i} width={120} height={28} radius={8} />)}
                </div>
                {/* Header */}
                <div style={{ padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9" }}>
                    <Shimmer width={38} height={38} radius={10} style={{ flexShrink: 0 }} />
                    <div style={{ flex: 1 }}>
                        <Shimmer width={190} height={15} style={{ marginBottom: 8 }} />
                        <Shimmer width={250} height={10} />
                    </div>
                    <Shimmer width={150} height={40} radius={9} style={{ flexShrink: 0 }} />
                </div>
                {/* Filter row */}
                <div style={{ padding: "16px 24px", borderBottom: "1px solid #f3f4f6" }}>
                    <Row className="g-2">
                        {Array.from({ length: filters }).map((_, i) => (
                            <Col xl={2} lg={3} md={6} sm={12} key={i} className="mb-2">
                                <Shimmer width="55%" height={11} style={{ marginBottom: 7 }} />
                                <Shimmer width="100%" height={42} radius={9} />
                            </Col>
                        ))}
                    </Row>
                </div>
                {/* Table */}
                <div style={{ padding: "20px 24px" }}>
                    <MaterialTableShimmer rows={6} cols={7} />
                </div>
            </div>
        </Container>
    </div>
);

export default MaterialPageShimmer;
